import { render, staticRenderFns } from "./FoodDistributionAllBoxes.vue?vue&type=template&id=4481c0f4&"
import script from "./FoodDistributionAllBoxes.vue?vue&type=script&lang=js&"
export * from "./FoodDistributionAllBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports